<template>
  <div class="mk-button mk-table-button"  @click="closeCallback(table)">
    <img class="mk-table-button__image" :src="require(`@/assets/images/${table.image}`)" />
    <div class="mk-table-button__title">
      {{$t(table.title)}}
    </div>
  </div>
</template>

<script>
/**
 * Table Button
 * @author David <david.prenninger@gmx.de>
 *
 * This component is a general button displaying an image and text.
 * On click a callback function is activated, mirrowing the table value.
 */
export default {
  props: {
    table: Object,
    closeCallback: Function,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-table-button {
  display: flex;
  flex-direction: column;
  box-shadow: $bs_md;
  margin: 10px;
  padding: 10px;
  align-items: center;
  justify-content: center;
  border-radius: $br_md;
  min-width: fit-content;

  &__title {
    font-size: 20;
    padding: 10px;
    color: $c_primary_lighter;
  }

  &__image {
    max-width: 150px;
    height: 150px;
  }
}

</style>
